export default "__VITE_ASSET__CNGzTGQq__"